import { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  ManageModulesStringLabels,
  ResourcesLabels,
} from "../../../../util/Strings";
import "../../office-home-tabs/OfficeTabs.css";
import "../../../../styles/screens/client-visit-details/manage-module/EventsList.css";
import ResourcesList from "./ResourcesList";
import ResourcesListForm from "./ResourcesListForm";
import VisitResourcesList from "./VisitResourcesList";

const Resources = ({ isVisit }) => {
  const [showCreateNewForm, setShowCreateNewForm] = useState(false);
  const location = useLocation();

  const setShowModal = (checked) => {
      setShowCreateNewForm(checked);
  }

  return (
    <div className="users-list-container">
      <div className="users-list-header-container">
        <div className="event-list-heading">
          {location.pathname.includes("resources") ? (
            ResourcesLabels.visitRelatedResources
          ) : (
            <div>
              {ResourcesLabels.generalResources}
              <p className="resource-note">{ResourcesLabels.generalDes}</p>
            </div>
          )}
        </div>
        <div className="add-button">
          <button
            style={{ minWidth: 150 }}
            onClick={() => setShowCreateNewForm(true)}
            className="button-style"
          >
            {isVisit
              ? ManageModulesStringLabels.importResources
              : ManageModulesStringLabels.addResource}
          </button>
        </div>
      </div>
      {isVisit ? (
        <>
          <VisitResourcesList showModal={showCreateNewForm} setShowModal={setShowModal}/>
        </>
      ) : (
        <>
          <ResourcesList />
          <ResourcesListForm
            editMode={false}
            show={showCreateNewForm}
            onClickNext={() => setShowCreateNewForm(false)}
          />
        </>
      )}
    </div>
  );
};

export default Resources;
